import { render, staticRenderFns } from "./UploadFileDialog.vue?vue&type=template&id=52e73a96&scoped=true"
import script from "./UploadFileDialog.vue?vue&type=script&lang=js"
export * from "./UploadFileDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadFileDialog.vue?vue&type=style&index=0&id=52e73a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e73a96",
  null
  
)

export default component.exports